import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import bookings, { paginationType } from "../../apiConfigs/bookings";
import { ReactComponent as SearchSVG } from "../../assets/icons/search.svg";
import Pagination from "../../components/Pagination";
import Button from "../../designComponents/Button";
import { ButtonTab } from "../../designComponents/ButtonTab";
import Input from "../../designComponents/Input";
import Table from "../../designComponents/Table";
import { renderstatus } from "../../designComponents/Table/renderMethods";
import { debounce } from "../../utils/debounce";
import requestAPI from "../../utils/requestAPI";
import { SearchInputWrapperStyled } from "../Users/style";
import { ReactComponent as View } from "../../assets/view.svg";
import {
  AcceptButton,
  ButtonsSection,
  RejectButton,
  Title,
  Wrapper,
} from "../Properties/Details/styles";
import ReusableModalButton from "../../designComponents/FilterButton";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";

type BookingsType = {
  _id: string;
  status: string;
  property: {
    address: string;
    price: string;
  };
};

const Bookings = () => {
  const navigate = useNavigate();
  const [cardKey, setCardKey] = useState<string>("all");
  const [bookingsData, setBookingsData] = useState<BookingsType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    limit: 10,
    search: "",
    totalPages: 1,
    total: 0,
    bedrooms: 0,
    bathrooms: 0,
    price: 0,
  });

  const getAllBookings = async (params: paginationType) => {
    setLoading(true);
    try {
      const query = {
        page: params.page,
        limit: params.limit,
        search: params.search,
        totalPages: params.totalPages,
        total: params.total,
        bedrooms: params.bedrooms,
        bathrooms: params.bathrooms,
        status: cardKey !== "all" ? cardKey : "",
      };
      const response = await requestAPI(bookings.getProperties(query));
      setBookingsData(response.bookings);

      setPaginationParams((prevParams) => ({
        ...prevParams,
        totalPages: response?.pagination?.totalPages,
        total: response?.pagination?.total,
      }));
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };
  const delayedFetch = useCallback(debounce(getAllBookings, 300), [cardKey]);

  useEffect(() => {
    delayedFetch(paginationParams);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPaginationParams((prevParams) => {
      const updatedParams = { ...prevParams, search: value, page: 1 };
      delayedFetch(updatedParams);
      return updatedParams;
    });
  };

  const handleCurrentPage = (page: number) => {
    delayedFetch({ ...paginationParams, page });
    setPaginationParams((prevParams) => ({ ...prevParams, page }));
  };

  const handleLimitChange = (limit: number) => {
    delayedFetch({ ...paginationParams, limit, page: 1 });

    setPaginationParams((prevParams) => ({ ...prevParams, limit, page: 1 }));
  };

  const tableData = {
    headings: [
      { key: "sn", label: "SN" },
      { key: "address", label: "Address of the Property" },
      // { key: "price", label: "Price" },
      { key: "status", label: "Status" },
      { key: "actions", label: "Actions" },
    ],
    body: Array.isArray(bookingsData)
      ? bookingsData.map((booking, index) => ({
          id: booking?._id,
          sn: index + 1 + ".",
          address: booking?.property?.address,
          status: renderstatus("OPEN"),
          actions: (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <View fill="#7E7E7E"></View>
            </div>
          ),
        }))
      : [],
  };
  return (
    <Wrapper>
      <ButtonsSection>
        <Title>Booking Management</Title>
      </ButtonsSection>
      <ButtonsSection>
        <SearchInputWrapperStyled style={{ width: 367, paddingTop: 15 }}>
          <Input
            value={paginationParams.search}
            name="bookings"
            onChange={handleInputChange}
            placeholder="Search Bookings"
            iconLeft={<SearchSVG />}
          />
        </SearchInputWrapperStyled>
        <ButtonsSection>
          {/* <ReusableModalButton icon>
            <LabelInputField
              onChange={(e) => {
                setPaginationParams({
                  ...paginationParams,
                  bedrooms: parseInt(e.target.value),
                });
              }}
              name="Text"
              label="No of bedrooms"
              style={{
                label: {
                  fontSize: "14px",
                  fontWeight: "500px",
                  color: "#555A77",
                },
                input: {
                  width: "100%",
                  height: 50,
                  border: "1px solid #F1EFFB",
                  padding: 8,
                  borderRadius: 6,
                },
                container: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 6,
                  paddingTop: 14,
                },
              }}
            ></LabelInputField>
            <LabelInputField
              onChange={(e) => {
                setPaginationParams({
                  ...paginationParams,
                  bathrooms: parseInt(e.target.value),
                });
              }}
              name="Text"
              label="No of Bathrooms"
              style={{
                label: {
                  fontSize: "14px",
                  fontWeight: "500px",
                  color: "#555A77",
                },
                input: {
                  width: "100%",
                  height: 50,
                  border: "1px solid #F1EFFB",
                  padding: 8,
                  borderRadius: 6,
                },
                container: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 6,
                  paddingTop: 14,
                },
              }}
            ></LabelInputField>
            <ButtonsSection>
              <LabelInputField
                name="Text"
                label="Price To"
                style={{
                  label: {
                    fontSize: "14px",
                    fontWeight: "500px",
                    color: "#555A77",
                  },
                  input: {
                    width: "100%",
                    height: 50,
                    border: "1px solid #F1EFFB",
                    padding: 8,
                    borderRadius: 6,
                  },
                  container: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    paddingTop: 14,
                  },
                }}
              ></LabelInputField>
            </ButtonsSection>

            <ButtonsSection style={{ paddingTop: 20 }}>
              <AcceptButton
                onClick={() => {
                  delayedFetch(paginationParams);
                }}
              >
                Apply
              </AcceptButton>
              <RejectButton
                onClick={() => {
                  setPaginationParams({
                    page: 1,
                    limit: 10,
                    search: "",
                    totalPages: 1,
                    total: 0,
                    bedrooms: 0,
                    bathrooms: 0,
                    price: 0,
                  });
                  delayedFetch(paginationParams);
                }}
              >
                Reset
              </RejectButton>
            </ButtonsSection>
          </ReusableModalButton> */}
        </ButtonsSection>
      </ButtonsSection>
      <Table
        tableData={tableData}
        isLoading={loading}
        noData="No data to display."
        rowClick={(id) => navigate(id)}
        headingBgColor="#f0f0f0"
        showMenuIcon={false}
        evenRowBgColor="#fafafa"
      />
      <Pagination
        activePage={paginationParams.page}
        totalPages={paginationParams.totalPages}
        limit={paginationParams.limit}
        onCurrentPageChange={handleCurrentPage}
        onLimitChange={handleLimitChange}
      />
    </Wrapper>
  );
};

export default Bookings;
